import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UserInterface, WorkspaceVirtualAgent } from 'voxr-shared';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss'
})
export class UserAvatarComponent {
  name: string = ' ';
  initials: string = ' ';

  _user?: UserInterface;
  _agent?: WorkspaceVirtualAgent;
  @Input({ required: true }) set user(value: UserInterface | WorkspaceVirtualAgent | undefined) {
    if (!value) {
      this.name = ' ';
      return;
    }

    this._agent = (<any>value).id ? value as WorkspaceVirtualAgent : undefined;
    this._user = this._agent ? undefined : value as UserInterface;

    if (this._agent) this.name = this._agent.name;
    else if (this._user) this.name = (this._user.profile?.['firstName'] || this._user.profile?.['name'] || this._user.email || '') +
      (this._user.profile?.['lastName'] ? ' ' + this._user.profile['lastName'] : '');

    this.initials = this.name.split(' ').map((n: string) => n[0]).join('').toUpperCase();
    if (this.initials.length > 2) this.initials = this.initials.substring(0, 2);
  }
  get user() { return this._user || this._agent; }

}
